var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("location-hero", {
        attrs: {
          locationLabel: _vm.restListHeader.locationHero.locationLabel,
          backgroundImage: _vm.restListHeader.locationHero.backgroundImage,
          businessPhone: _vm.restListHeader.locationHero.businessPhone,
          mapCenterLat: _vm.restListHeader.locationHero.mapCenterLat,
          mapCenterLng: _vm.restListHeader.locationHero.mapCenterLng,
          mapDefaultZoom: _vm.restListHeader.locationHero.mapDefaultZoom,
          restListHeader: _vm.restListHeader,
        },
        on: {
          clearSelectedFilters: function ($event) {
            return _vm.handleClearFilters()
          },
        },
      }),
      _vm._v(" "),
      _c("category-filter-list", {
        attrs: {
          filters: _vm.tagList,
          clearSelectedFilters: _vm.clearSelectedFilters,
        },
        on: {
          filterSelected: function ($event) {
            _vm.clearSelectedFilters = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }